/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';

import { ContactTermsPayables, ContactTermsReceivables } from '../contacts';
import { MailRequirementSetting } from './mail-requirement-setting.enum';
import {
  AccountingMigrationDataDto,
  JobContractDaysPeriodType,
  JobContractStartBasedOnType,
  PolicyReportingMethod,
  SystemVarsAccountingExpenseDto,
  SystemVarsAccountingJobsDto,
  SystemVarsAccountingReceivableDto,
  SystemVarsAccountsIntranetDto,
  SystemVarsAccountsTwilioDto,
  SystemVarsAccountsXeroDto,
  SystemVarsAccountsXeroSyncDto,
  SystemVarsAccountsXeroSyncTypeDto,
  SystemVarsAccountsXeroUrlDto,
  SystemVarsContactsDto,
  SystemVarsFranchiseeDto,
  SystemVarsJobDto,
  SystemVarsLedgerDto,
  SystemVarsManagerDto,
  SystemVarsMasterZoneDetailsDto,
  SystemVarsPayablesDto,
  SystemVarsReceivablesDto,
  SystemVarsSupervisorDto,
  XeroAccountCreateRequestDto,
  XeroSyncType,
} from './system-vars.dto';

export const SystemVarsFranchiseeMapper = entity<SystemVarsFranchiseeDto>({
  formedDate: date(DateFormat.Date),
  billing: subentity<any>({
    contractSignedDate: date(DateFormat.Date),
    depositDate: date(DateFormat.Date),
    originalCommencement: date(DateFormat.Date),
    currentAgreement: date(DateFormat.Date),
    renewalDate: date(DateFormat.Date),
    officeClosed: date(DateFormat.Date),
    onSellDate: date(DateFormat.Date),
  }),
});

export const SystemVarsContactsMapper = entity<SystemVarsContactsDto>({
  onNotEnteredForContact: enumeration(MailRequirementSetting),
});
export const SystemVarsMasterZoneDetailsMapper = entity<SystemVarsMasterZoneDetailsDto>();

export const SystemVarsAccountsTwilioMapper = entity<SystemVarsAccountsTwilioDto>();
export const SystemVarsAccountsIntranetMapper = entity<SystemVarsAccountsIntranetDto>({});
export const SystemVarsAccountsXeroMapper = entity<SystemVarsAccountsXeroDto>({
  xeroSyncLastCC: date(DateFormat.DateTime),
  xeroSyncLastJobs: date(DateFormat.DateTime),
  xeroSyncLastContacts: date(DateFormat.DateTime),
  xeroSyncLastInvoices: date(DateFormat.DateTime),
  xeroSyncType: enumeration(XeroSyncType),
});
export const SystemVarsAccountsXeroUrlMapper = entity<SystemVarsAccountsXeroUrlDto>({});
export const SystemVarsAccountsXeroSyncMapper = entity<SystemVarsAccountsXeroSyncDto>({});
export const SystemVarsAccountsXeroSyncTypeMapper = entity<SystemVarsAccountsXeroSyncTypeDto>({});

export const SystemVarsJobMapper = entity<SystemVarsJobDto>({
  jobContractStartBasedOn: enumeration(JobContractStartBasedOnType),
  jobContractConstructionPeriodIncludes: enumeration(JobContractDaysPeriodType),
});

export const SystemVarsReceivablesMapper = entity<SystemVarsReceivablesDto>({
  recDefaultPaymentDue: enumeration(ContactTermsReceivables),
});

export const SystemVarsManagerMapper = entity<SystemVarsManagerDto>({
  policyStartDate: date(DateFormat.Date),
  policyReportingMethod: enumeration(PolicyReportingMethod),
});

export const SystemVarsSupervisorMapper = entity<SystemVarsSupervisorDto>({});

export const SystemVarsPayablesMapper = entity<SystemVarsPayablesDto>({
  payDefaultPaymentDue: enumeration(ContactTermsPayables),
});

export const SystemVarsLedgerMapper = entity<SystemVarsLedgerDto>({
  conversionDate: date(DateFormat.Date),
});

export const SystemVarsAccountingReceivableMapper = entity<SystemVarsAccountingReceivableDto>({});
export const SystemVarsAccountingJobsMapper = entity<SystemVarsAccountingJobsDto>({});
export const SystemVarsAccountingExpenseMapper = entity<SystemVarsAccountingExpenseDto>({});

export const AccountingMigrationDataMapper = entity<AccountingMigrationDataDto>({});
export const XeroAccountCreateRequestMapper = entity<XeroAccountCreateRequestDto>({});
